import { Injectable, signal, computed } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private _isLoading = signal(false);
  readonly isLoading = computed(() => this._isLoading());

  show(): void {
    this._isLoading.set(true);
  }
  hide(): void {
    this._isLoading.set(false);
  }

  track<T>(source$: Observable<T>): Observable<T> {
    this.show();
    return source$.pipe(finalize(() => this.hide()));
  }
}
